import { NodeResizer, NodeResizerProps } from 'reactflow';
import { useVersionControlStore } from '../../store/storeVersionControl';

const GuardedNodeResizer = (props: NodeResizerProps) => {
  const isProductionView = useVersionControlStore(
    state => state.isProductionView,
  );

  if (isProductionView) {
    return null;
  }

  return <NodeResizer {...props} />;
};

export default GuardedNodeResizer;
